import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFilter$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFilter extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '74bf181695eb743638630c44f870c83026737b88', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd9e771e1de4e14fc63076e5a0ede743476265281', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8c01be2772215e3fffbf16315e2fb1f7f52e1d32', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6.25h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3V9.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5zm-3 7a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM8.5 11H8a.5.5 0 0 0-.5.5v1.75h-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4v1.75a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5m-5-4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-filter", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-filter"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-filter":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFilter$1);
            }
            break;
    } });
}

const CosmosIconFilter = CosmosIconFilter$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFilter, defineCustomElement };
